import { useState } from "react";

export interface useGetCurrentLocationResult {
    data: any,
    fetch: () => void,
    isSuccess: boolean,
    isLoading: boolean,
    error: any,
}

const options = {
    enableHighAccuracy: true,
    timeout: 5000,
    maximumAge: 0,
};

function useGetCurrentLocation(): useGetCurrentLocationResult {
    const [success, setSuccess] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState();
    const [data, setData] = useState();

    const getLocation = () => {
        setSuccess(false);
        setError(undefined);
        setIsLoading(true);
        navigator.geolocation.getCurrentPosition(onSuccess, onError, options);
    }

    const onSuccess = (pos) => {
        const crd = pos.coords;
        console.log("Current position", crd);
        setData(crd);
        setSuccess(true);
        setIsLoading(false);
    }

    const onError = (err) => {
        console.warn(`ERROR(${err.code}): ${err.message}`);
        setIsLoading(false);
        setError(err);
    }

    return {
        data: data,
        isSuccess: success,
        error: error,
        fetch: getLocation,
        isLoading: isLoading,
    }
}

export default useGetCurrentLocation;